(function () {
  var MAT_LABEL = { viola: 'Calacatta Viola', amazonite: 'Amazonite', seasons: 'Four Seasons' };
  var SCENE_LABEL = { dining: 'Dining table', media: 'Media wall' };

  function initFinishes(root) {
    var strip = root.querySelector('[data-ss-finishes]');
    if (!strip) return;
    var panels = Array.prototype.slice.call(strip.querySelectorAll('[data-ss-finish]'));
    var canHover = window.matchMedia('(hover: hover)').matches;

    function open(panel) {
      panels.forEach(function (p) {
        var on = p === panel;
        p.classList.toggle('is-open', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    panels.forEach(function (p) {
      p.addEventListener('click', function () { open(p); });
      if (canHover) p.addEventListener('mouseenter', function () { open(p); });
    });
  }

  function initComparator(root) {
    var cmp = root.querySelector('[data-ss-cmp]');
    if (!cmp) return;
    var stage = cmp.querySelector('[data-ss-stage]');
    var range = cmp.querySelector('[data-ss-wipe]');
    var labelL = cmp.querySelector('[data-ss-label-left]');
    var labelR = cmp.querySelector('[data-ss-label-right]');
    var layers = Array.prototype.slice.call(cmp.querySelectorAll('[data-ss-layer]'));

    var state = { scene: 'dining', left: 'viola', right: 'amazonite' };

    function press(selector, attr, value) {
      Array.prototype.forEach.call(cmp.querySelectorAll(selector), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute(attr) === value ? 'true' : 'false');
      });
    }

    function render() {
      stage.setAttribute('data-scene', state.scene);
      layers.forEach(function (l) {
        var isScene = l.getAttribute('data-scene') === state.scene;
        var mat = l.getAttribute('data-mat');
        l.classList.toggle('is-left', isScene && mat === state.left);
        l.classList.toggle('is-right', isScene && mat === state.right);
      });
      press('[data-ss-scene]', 'data-ss-scene', state.scene);
      press('[data-ss-left]', 'data-ss-left', state.left);
      press('[data-ss-right]', 'data-ss-right', state.right);
      labelL.textContent = SCENE_LABEL[state.scene] + ' · ' + MAT_LABEL[state.left];
      labelR.textContent = MAT_LABEL[state.right];
    }

    Array.prototype.forEach.call(cmp.querySelectorAll('[data-ss-scene]'), function (b) {
      b.addEventListener('click', function () { state.scene = b.getAttribute('data-ss-scene'); render(); });
    });
    // Picking a stone that is already on the other side swaps the two, so the
    // comparator never ends up showing the same material against itself.
    Array.prototype.forEach.call(cmp.querySelectorAll('[data-ss-left]'), function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ss-left');
        if (v === state.right) state.right = state.left;
        state.left = v;
        render();
      });
    });
    Array.prototype.forEach.call(cmp.querySelectorAll('[data-ss-right]'), function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ss-right');
        if (v === state.left) state.left = state.right;
        state.right = v;
        render();
      });
    });

    // A native range thumb travels from half its width to (track - half its
    // width), so feeding the raw value straight through would leave the divider
    // adrift from the handle by up to half a thumb at either end. Map the value
    // onto the thumb's real centre instead.
    function setWipe() {
      var v = parseFloat(range.value) / 100;
      var tw = parseFloat(getComputedStyle(stage).getPropertyValue('--ss-thumb-w')) || 0;
      var w = range.getBoundingClientRect().width;
      var pct = w > tw ? ((tw / 2 + (w - tw) * v) / w) * 100 : v * 100;
      stage.style.setProperty('--ss-wipe', pct + '%');
    }
    range.addEventListener('input', setWipe);
    range.addEventListener('change', setWipe);
    window.addEventListener('resize', setWipe);

    setWipe();
    render();
  }

  var MATERIALS = ['Marble', 'Granite', 'Quartzite', 'Onyx', 'Travertine', 'Limestone', 'Porcelain', 'Semi-precious'];
  var SOURCES = {
    'Italy': { m: ['Marble', 'Onyx', 'Travertine', 'Limestone', 'Porcelain'], note: "The Apuan Alps — Calacatta, Statuario, Arabescato. Also the world's benchmark for large-format porcelain and sintered stone." },
    'Spain': { m: ['Marble', 'Limestone', 'Porcelain'], note: 'Levante browns and Macael whites, plus the porcelain and sintered-stone industry around Castellón.' },
    'Greece': { m: ['Marble'], note: 'Thassos and Drama — pure whites and dolomitic marbles. The calmest whites available anywhere.' },
    'Portugal': { m: ['Marble', 'Granite', 'Limestone'], note: 'Estremoz marbles, hard northern granites and the creamy limestones used across southern Europe.' },
    'North Macedonia': { m: ['Marble'], note: 'Sivec — a dense, near-translucent white marble, and one of the few true alternatives to Italian statuario.' },
    'Turkey': { m: ['Marble', 'Travertine', 'Onyx', 'Limestone'], note: 'Vast, consistent seams — travertine, Anatolian greys and honey onyx. The region for large, tonally matched jobs.' },
    'Egypt': { m: ['Marble', 'Granite', 'Limestone'], note: 'Galala and Sinai creams, plus the red and black granites quarried near Aswan.' },
    'Iran': { m: ['Marble', 'Onyx', 'Travertine'], note: 'Some of the finest onyx in the world, and creams with exceptional translucency.' },
    'Oman': { m: ['Marble', 'Limestone'], note: 'Regional whites and pearls, on our doorstep — short lead times and low freight.' },
    'United Arab Emirates': { m: MATERIALS.slice(), note: 'Dubai: our own yard, saws and fabrication. Every stone on this map lands here before it lands in your home.' },
    'Saudi Arabia': { m: ['Marble', 'Limestone'], note: 'Regional creams and beiges for large-area work.' },
    'India': { m: ['Granite', 'Marble', 'Quartzite', 'Semi-precious'], note: 'The deepest granite offering anywhere — including Lemurian Blue — plus quartzites, Rajasthan marbles and agate.' },
    'Pakistan': { m: ['Onyx', 'Marble', 'Semi-precious'], note: 'Ziarat whites and the green and honey onyx from Balochistan, plus semi-precious material by the piece.' },
    'China': { m: ['Granite', 'Marble', 'Quartzite', 'Porcelain'], note: 'Scale and engineered consistency: granites, porcelain slabs and quartz surfacing.' },
    'Vietnam': { m: ['Marble', 'Porcelain'], note: 'Bright crystalline whites and a fast-growing porcelain sector.' },
    'Brazil': { m: ['Quartzite', 'Granite', 'Onyx', 'Semi-precious'], note: 'Minas Gerais and Espírito Santo — exotic quartzites that look like marble and behave like granite, and the source of most agate and amethyst.' },
    'Mexico': { m: ['Onyx', 'Marble', 'Travertine'], note: 'Backlit onyx in greens, ambers and whites — the material for a lit feature.' },
    'Namibia': { m: ['Granite', 'Semi-precious'], note: 'Deep blue and blue-pearl granites from the Namib, and sodalite blue. Rare, and worth the wait.' },
    'South Africa': { m: ['Granite'], note: 'Nero Impala and the hard-wearing dark granites that carry high-traffic floors.' },
    'Zimbabwe': { m: ['Granite'], note: 'Absolute Black — the truest black granite quarried anywhere.' },
    'Norway': { m: ['Granite'], note: 'Blue pearl and emerald pearl — granites with a visible crystal shimmer.' }
  };
  // The world-atlas topojson names a couple of these differently.
  var ALIAS = { 'Macedonia': 'North Macedonia', 'UAE': 'United Arab Emirates' };
  function keyFor(name) { return ALIAS[name] || name; }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-ss-lib="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === '1') return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.crossOrigin = 'anonymous';
      s.setAttribute('data-ss-lib', src);
      s.onload = function () { s.setAttribute('data-loaded', '1'); resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function buildMap(root) {
    var host = root.querySelector('[data-ss-map]');
    if (!host) return;
    var canvas = host.querySelector('[data-ss-map-canvas]');
    var chipBox = host.querySelector('[data-ss-chips]');
    var countBox = host.querySelector('[data-ss-map-counts]');
    var eyebrow = host.querySelector('[data-ss-map-eyebrow]');
    var title = host.querySelector('[data-ss-map-title]');
    var body = host.querySelector('[data-ss-map-body]');
    var tagBox = host.querySelector('[data-ss-map-tags]');

    var active = null, selected = null;
    var names = Object.keys(SOURCES);

    // Chips render immediately so the filter list is useful even if the
    // geography request fails.
    ['All materials'].concat(MATERIALS).forEach(function (label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ss-chip';
      b.textContent = label;
      b.addEventListener('click', function () {
        active = (label === 'All materials' || active === label) ? null : label;
        selected = null;
        render();
      });
      chipBox.appendChild(b);
    });

    countBox.innerHTML = '';
    [['Sourcing regions', names.length]].concat(MATERIALS.map(function (m) {
      return [m, names.filter(function (n) { return SOURCES[n].m.indexOf(m) > -1; }).length];
    })).forEach(function (row) {
      var d = document.createElement('div');
      var s = document.createElement('span');
      var b = document.createElement('b');
      s.textContent = row[0];
      b.textContent = row[1];
      d.appendChild(s);
      d.appendChild(b);
      countBox.appendChild(d);
    });

    var svg = null, path = null, byName = new Map();

    function render() {
      Array.prototype.forEach.call(chipBox.children, function (b) {
        var isAll = b.textContent === 'All materials';
        b.setAttribute('aria-pressed', (active === null && isAll) || active === b.textContent ? 'true' : 'false');
      });

      if (svg) {
        svg.selectAll('path.src')
          .classed('dim', function (d) { return active !== null && SOURCES[keyFor(d.properties.name)].m.indexOf(active) === -1; })
          .classed('on', function (d) { return active !== null && SOURCES[keyFor(d.properties.name)].m.indexOf(active) > -1; })
          .classed('sel', function (d) { return selected === keyFor(d.properties.name); });
        svg.selectAll('circle.dot')
          .classed('dim', function (n) { return active !== null && SOURCES[n].m.indexOf(active) === -1; })
          .attr('r', function (n) { return selected === n ? 5.5 : 3.4; });
      }

      var tags = [];
      if (selected) {
        eyebrow.textContent = 'Sourcing region';
        title.textContent = selected;
        body.textContent = SOURCES[selected].note;
        tags = SOURCES[selected].m;
      } else if (active) {
        var list = names.filter(function (n) { return SOURCES[n].m.indexOf(active) > -1; });
        eyebrow.textContent = active;
        title.textContent = list.length + ' regions supply it';
        body.textContent = 'Tap any highlighted country for what we bring in from it, and why we buy there.';
        tags = list;
      } else {
        eyebrow.textContent = 'Global sourcing';
        title.textContent = 'Every corner of the world';
        body.textContent = 'Tap a country on the interactive map to see what we bring in from there, or filter by material and find out which regions supply it.';
      }
      tagBox.innerHTML = '';
      tags.forEach(function (t) {
        var s = document.createElement('span');
        s.textContent = t;
        tagBox.appendChild(s);
      });
    }

    render();

    Promise.all([
      loadScript('https://unpkg.com/d3@7.9.0/dist/d3.min.js'),
      loadScript('https://unpkg.com/topojson-client@3.1.0/dist/topojson-client.min.js')
    ]).then(function () {
      return window.d3.json('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json');
    }).then(function (topo) {
      var d3 = window.d3;
      var width = 980, height = 470;
      var features = window.topojson.feature(topo, topo.objects.countries).features;
      features.forEach(function (f) { byName.set(keyFor(f.properties.name), f); });

      svg = d3.select(canvas).append('svg').attr('viewBox', '0 0 ' + width + ' ' + height);
      var projection = d3.geoNaturalEarth1().scale(185).translate([width / 2, height / 2 + 12]);
      path = d3.geoPath(projection);

      svg.append('g').selectAll('path').data(features).join('path')
        .attr('d', path)
        .attr('class', function (d) { return SOURCES[keyFor(d.properties.name)] ? 'country src' : 'country'; })
        .on('click', function (e, d) {
          var k = keyFor(d.properties.name);
          if (SOURCES[k]) { selected = k; render(); }
        })
        .append('title').text(function (d) { return keyFor(d.properties.name); });

      svg.append('g').selectAll('circle')
        .data(names.filter(function (n) { return byName.has(n); })).join('circle')
        .attr('r', 3.4)
        .attr('transform', function (n) { return 'translate(' + path.centroid(byName.get(n)) + ')'; })
        .attr('class', 'dot')
        .on('click', function (e, n) { selected = n; render(); })
        .append('title').text(function (n) { return n; });

      render();
    }).catch(function () {
      canvas.innerHTML = '<p style="padding:24px 0;color:rgb(243 242 236 / 0.7)">Map data could not be loaded.</p>';
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-stone]'), function (root) {
      if (root.dataset.ssReady === '1') return;
      root.dataset.ssReady = '1';
      initFinishes(root);
      initComparator(root);
      buildMap(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // The theme editor tears a section down and rebuilds it on every edit.
  document.addEventListener('shopify:section:load', init);
})();
